import React from 'react';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Reusable CloseButton component.
 * Props: onClick, size, color, ariaLabel, sx, className
 */
function CloseButton({ onClick, size = 'small', color = 'primary', ariaLabel = 'close', sx, className }) {
  return (
    <IconButton onClick={onClick} size={size} color={color} aria-label={ariaLabel} sx={sx} className={className}>
      <CancelIcon />
    </IconButton>
  );
}

export default CloseButton;
